export const EDIT_SUCCESS = 'Группа юзеров обновлена';
export const EDIT_ERROR = 'Не удалось обновить группу юзеров';
